module.exports = __webpack_public_path__ + "d278b08ae63784ab50c1941233e166e9.png";